/* eslint-disable @typescript-eslint/naming-convention */
export enum ImageSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  FULL = 'FULL',
}
